import { ReactComponent as WizadIcon } from '../../../../assets/wizard.svg';
import { useLanguage } from '../../../../contexts/languageContext';

export const DAPAppWaitingRoom = () => {
  const { translation } = useLanguage();

  return (
    <div className="onboarding-step">
      <div className="onboarding-step__illustration">
        <WizadIcon />
      </div>
      <h2
        className="onboarding-step__header app-waiting-room"
        dangerouslySetInnerHTML={{ __html: translation.onboarding?.dapCode?.appTitle }}
      />
      <p
        className="onboarding-step__description app-waiting-room"
        dangerouslySetInnerHTML={{ __html: translation.onboarding?.dapCode?.appText }}
      />
    </div>
  );
};
